import React from "react";
import Grid from "@mui/material/Grid";
import { Card, CardActionArea, CardContent, Typography } from "@mui/material";
import PlaceCard from "./PlaceCard";
import ReasonChoice from "./ReasonChoice";
import PractitionerCard from "./PractitionerCard";
import moment from "moment";
import "moment/locale/fr";
moment.locale("fr");

export default function ChoiceHistory({ page, setPage }) {
  return (
    <Grid item order={{ xs: 1, md: 2 }} xs={12} md={4} mt={5}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h5" align="center">
            Rappel de vos choix
          </Typography>
        </Grid>

        {/* Etablissement */}
        {page.place !== null && (
          <Grid container item xs={12} mt={2}>
            <Grid item xs={12}>
              <Typography variant="body1" align="center" my={1}>
                Etablissement :
              </Typography>
            </Grid>

            <Grid container item xs={12} justifyContent="center">
              <PlaceCard setPage={setPage} page={page} data={page.place} />
            </Grid>
          </Grid>
        )}
      </Grid>

      {/* Motif */}
      {page.motif !== null && (
        <Grid container item xs={12} mt={2}>
          <Grid item xs={12}>
            <Typography variant="body1" align="center" my={1}>
              Motif :
            </Typography>
          </Grid>

          <Grid container item xs={12} justifyContent="center">
            <ReasonChoice setPage={setPage} page={page} data={page.motif} />
          </Grid>
        </Grid>
      )}

      {/* Praticien */}
      {page.praticien !== null && (
        <Grid container item xs={12} mt={2} justifyContent="center">
          <Grid item xs={12}>
            <Typography variant="body1" align="center" my={1}>
              Praticien :
            </Typography>
          </Grid>

          <Grid container item xs={12} justifyContent="center">
            <PractitionerCard
              setPage={setPage}
              page={page}
              data={page.praticien}
            />
          </Grid>
        </Grid>
      )}

      {/* Date du rendez-vous */}
      {page.date !== "" && (
        <Grid container item xs={12} mt={2} justifyContent="center">
          <Grid item>
            <Typography variant="body1" align="center" my={1}>
              Date de rendez-vous :
            </Typography>
          </Grid>

          <Grid container item xs={12} justifyContent="center">
            <CardActionArea
              style={{ width: "360px" }}
              onClick={(e) => {
                setPage({
                  ...page,
                  page: 3,
                  date: "",
                  dateTo: "",
                  valid: false,
                });
              }}
            >
              {/* Date */}
              <Card sx={{ "&:hover": { boxShadow: 4 } }}>
                <CardContent
                // style={{
                //   textTransform: "none",
                //   color: "black",
                //   backgroundColor: "white",
                // }}
                >
                  <Typography align="center">
                    {moment(page.date).format("ddd DD MM YYYY [à] HH[h]mm")}
                  </Typography>
                </CardContent>
              </Card>
            </CardActionArea>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
